export default __webpack_public_path__ + "static/media/publish-finished-icon.cb7a7f3f.svg";